import AddTwoToneIcon from '@mui/icons-material/AddTwoTone'
import { Button, Card, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import _ from 'lodash'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import { usePromiseTracker } from 'react-promise-tracker'
import { useNavigate } from 'react-router'
import SuspenseLoader from 'src/components/SuspenseLoader'
import { WbTableRowDeleteButton } from 'src/components/WbTable'
import { AdminPermissionsService } from 'src/services/adminPermissionsService'
import MasterWorkoutViewModel from 'src/viewmodels/MasterWorkoutViewModel'
import MasterWorkoutMaxForm from './MasterWorkoutMaxForm'

interface MasterWorkoutMaxListProps {
	viewModel: MasterWorkoutViewModel
}

const MasterWorkoutMaxList: React.FC<MasterWorkoutMaxListProps> = observer(({ viewModel }) => {
	const navigate = useNavigate()
	const {
        masterWorkout,
		addWorkoutMax,
		editWorkoutMax,
		removeWorkoutMax,
		saveWorkoutMaxes,
		fetch,
		lookups
	} = viewModel

	const handleSaveChanges = useCallback(() => {
		saveWorkoutMaxes().then((id) => {
			// Keep page opened
			if (masterWorkout.id > 0) fetch(`${id}`)
			// Navigate to id and update params.id
			else navigate(`/master-workouts/${id}`)
		})
	}, [masterWorkout.id])

	const { canCreate, canDelete, verifyEdit } = AdminPermissionsService.instance.masterWorkoutPage
	const canEdit = (_.isNil(masterWorkout.id) && canCreate) || verifyEdit(masterWorkout.isPublic)

	const { promiseInProgress } = usePromiseTracker()

	return promiseInProgress ? (
		<SuspenseLoader />
	) : (
		<Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3} mt={1}>
			<Grid item xs={2} display="flex" justifyContent="start" alignItems="center">
				{canEdit && (
					<Button variant="outlined" startIcon={<AddTwoToneIcon fontSize="small" />} onClick={addWorkoutMax}>
						Add
					</Button>
				)}
			</Grid>

			<Grid item xs={10} display="flex" justifyContent="end" alignItems="center">
				{canEdit && (
					<Button sx={{ mt: { xs: 2, md: 0 }, mx: 1 }} variant="contained" onClick={handleSaveChanges}>
						Save Changes
					</Button>
				)}
			</Grid>

			<Grid item xs={12}>
				<TableContainer component={Card}>
					<Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell>Master Exercise Name</TableCell>
								<TableCell>Exercise Category</TableCell>
								<TableCell></TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{masterWorkout?.masterWorkoutMaxes?.map((max, idx) => (
								<TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
									<MasterWorkoutMaxForm initialValues={max} lookups={lookups} onSubmit={(values: any) => editWorkoutMax(idx, values)} />
									<TableCell>{canEdit && <WbTableRowDeleteButton onClick={() => removeWorkoutMax(idx)} />}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</Grid>
	)
})

export default MasterWorkoutMaxList
